export function setLastEditNow() {
  try {
    const now = new Date();
    localStorage.setItem('lastEditedAt', now.toISOString());

    const el = document.getElementById('last-edit');
    if (el) {
      const dtf = new Intl.DateTimeFormat('pt-BR', {
        dateStyle: 'short',
        timeStyle: 'short'
      });
      el.textContent = 'Última edição: ' + dtf.format(now);
    }
  } catch {
    /* ignore */
  }
}

export function initLastEditFromStorage() {
  try {
    const el = document.getElementById('last-edit');
    if (!el) return;

    const stored = localStorage.getItem('lastEditedAt');
    if (stored) {
      const dt = new Date(stored);
      const dtf = new Intl.DateTimeFormat('pt-BR', {
        dateStyle: 'short',
        timeStyle: 'short'
      });
      el.textContent = 'Última edição: ' + dtf.format(dt);
    } else {
      el.textContent = 'Última edição: —';
    }
  } catch {
    /* ignore */
  }
}